module.exports = __webpack_public_path__ + "img/0.115fa5e1.png";